import React, { useState, useEffect } from "react";
import { Modal, Form, Input, InputNumber, Switch, Button, Select } from "antd";
import { ShowToast, Severty } from "../../helper/toast";
import callApi from "../../constants/API/CallApi";
import { addSubscription } from "../../constants/API/API"; // Replace with your actual API method

const SubscriptionAdd = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible]);

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const handleOk = async (values) => {
    setLoading(true);

    callApi({
      callback: addSubscription,
      payload: values,
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh(new Date().getTime());
        setVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const validateName = (_, value) => {
    if (!value) return Promise.reject("Please enter a subscription name");
    if (!/^[A-Z][a-zA-Z0-9 ]*$/.test(value)) {
      return Promise.reject(
        "Name must start with a capital letter and contain only letters, numbers, and spaces"
      );
    }
    return Promise.resolve();
  };

  return (
    <Modal
      open={visible}
      className="tab_modal"
      title="Add Subscription"
      okText="Create"
      onCancel={handleCancel}
      okButtonProps={{
        form: "create-subscription",
        htmlType: "submit",
        loading,
      }}
      destroyOnClose
    >
      <Form
        id="create-subscription"
        form={form}
        layout="vertical"
        onFinish={handleOk}
      >
        <Form.Item
          name="name"
          label="Subscription Name"
          rules={[{ required: true, validator: validateName }]}
        >
          <Input placeholder="Enter subscription name" />
        </Form.Item>

        <Form.Item
          name="price"
          label="Price (CAD)"
          rules={[{ required: true, message: "Please enter a price" }]}
        >
          <InputNumber
            min={0}
            style={{ width: "100%" }}
            placeholder="Enter price"
          />
        </Form.Item>

        <Form.Item
          name="validity"
          label="Validity Period"
          rules={[{ required: true, message: "Please enter validity period" }]}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Enter validity in months"
          >
            <Select.Option key={"month"}>Monthly</Select.Option>
            <Select.Option key={"year"}>Yearly</Select.Option>
          </Select>
        </Form.Item>

        {/* <Form.Item
          name="validity"
          label="Validity (months)"
          rules={[
            { required: true, message: "Please enter validity in months" },
          ]}
        >
          <InputNumber
            min={1}
            style={{ width: "100%" }}
            placeholder="Enter validity in months"
          />
        </Form.Item> */}

        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Please enter a description" }]}
        >
          <Input.TextArea rows={3} placeholder="Enter description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SubscriptionAdd;
